// extracted by mini-css-extract-plugin
module.exports = {"container":"UsernameInput_container__3dZr5","input":"UsernameInput_input__2wiSd","icon":"UsernameInput_icon__1vIhS"};